package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class Service(
    val category_id: Int? = null,
    val created_at: String? = null,
    val description: String? = null,
    val duration: Int? = null,
    val id: Int,
    val max_price: Int? = null,
    val name: String? = null,
    val organization_id: Int? = null,
    val pivot: Pivot? = null,
    val price: Int? = null,
    val updated_at: String? = null
)